import React, { useState } from 'react';
import Integrations from './components/Integrations';
import AddIntegration from './components/AddIntegration';
import EditIntegration from './components/EditIntegration';
import CutOffTime from './components/CutOffTime';
import { TState } from './types';
import css from './IntegrationPage.module.scss';

const IntegrationPage = () => {
  const [state, setState] = useState<TState>(TState.INTEGRATIONS); 
  return (
    <section className={css.root}>
      <div className={css.header}>Integration</div>
      {state === TState.INTEGRATIONS && <Integrations setState={setState} />}
      {state === TState.ADD && <AddIntegration setState={setState} />}
      {state === TState.EDIT && <EditIntegration setState={setState} />}
      {state === TState.CUT_OFF_TIME && <CutOffTime setState={setState} />}
    </section>
  );
}

export default IntegrationPage;
